import {EditorTransformPoint} from "../editor/editor-transform-point";
import {LayerGeometry} from "../../../document/model/layer";
import {Feature} from "geojson";

export class LocationPickerTranslatePoint extends EditorTransformPoint {
  static selectionAllowed: boolean = true;
  static selectionRequired: boolean = false;

  setup(opts) {
    if (opts.geometries.length === 0) {
      return {};
    }
    return super.setup(opts);
  }

  toDisplayFeatures(state, geojson, display) {
    if (!state.layerGeometry || state.layerGeometry.geometryId !== geojson.properties.id) {
      if (state.layerGeometry && state.layerGeometry.geometryId !== geojson.properties.id) {
        this.onTrash(state)
      }
      //when new feature is added on the fly
      let newState = this.setup({
        geometries: [{
          geometryId: geojson.properties.id,
          geometry: geojson
        }]
      });

      Object.keys(newState).forEach(prop => {
        state[prop] = newState[prop];
      });
    }

    super.toDisplayFeatures(state, geojson, display);
  }

  onTrash(state: any): void {
    if (state.layerGeometry) {
      this._ctx.api.delete(state.aim.id);
      this._ctx.store.render()
    }
  }

  contextMenu(state: any): any[] {
    let options = [];

    if (this.controller().interaction.hasTmpGeometries()) {
      options.push({
        label: "Finalize",
        icon: "/icons/toolbox/check.svg",
        command: () => {
          (this.controller().interaction.getDrawMode() as any).persist(this.controller().interaction.getDrawState());
        }
      });
    }

    return options;
  }


  attemptUpdateLayerGeometry(layerGeometry: LayerGeometry, feature: Feature, confirmCallback, closeCallback) {

  }
}
